function FormAnalytics() {
  return <div>This is analytics</div>;
}

export default FormAnalytics;
